import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0db13820")

_pushScopeId("data-v-0db13820")
const _hoisted_1 = {
  key: 0,
  class: "display-project"
}
const _hoisted_2 = { class: "item-name" }
const _hoisted_3 = { class: "item-value" }
const _hoisted_4 = { class: "item-name" }
const _hoisted_5 = { class: "item-value" }
const _hoisted_6 = { class: "item-name" }
const _hoisted_7 = { class: "item-value" }
const _hoisted_8 = { class: "item-name" }
const _hoisted_9 = { class: "item-value" }
const _hoisted_10 = { class: "item-name" }
const _hoisted_11 = { class: "item-value" }
const _hoisted_12 = { class: "item-name" }
const _hoisted_13 = { class: "item-value" }
const _hoisted_14 = { class: "item-name" }
const _hoisted_15 = { class: "item-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return ($props.project)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("p", null, [
          _createVNode("span", _hoisted_2, _toDisplayString($setup.t('Project.name')) + " : ", 1),
          _createVNode("span", _hoisted_3, _toDisplayString($props.project.name), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_4, _toDisplayString($setup.t('Project.address')) + " : ", 1),
          _createVNode("span", _hoisted_5, _toDisplayString($props.project.address), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_6, _toDisplayString($setup.t('Project.cp')) + " : ", 1),
          _createVNode("span", _hoisted_7, _toDisplayString($props.project.cp), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_8, _toDisplayString($setup.t('Project.city')) + " : ", 1),
          _createVNode("span", _hoisted_9, _toDisplayString($props.project.city), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_10, _toDisplayString($setup.t('Project.siret')) + " : ", 1),
          _createVNode("span", _hoisted_11, _toDisplayString($props.project.siret), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_12, _toDisplayString($setup.t('Project.email')) + " : ", 1),
          _createVNode("span", _hoisted_13, _toDisplayString($props.project.email), 1)
        ]),
        _createVNode("p", null, [
          _createVNode("span", _hoisted_14, _toDisplayString($setup.t('Project.phone')) + " : ", 1),
          _createVNode("span", _hoisted_15, _toDisplayString($props.project.phone), 1)
        ])
      ]))
    : _createCommentVNode("", true)
})